module.exports = __webpack_public_path__ + "img/view-icon.c00dbd8a.svg";